export enum CoupleTerminalErrorCode {
  CouldNotFindTerminal = "CouldNotFindTerminal",
  CoupledToActiveMerchant = "CoupledToActiveMerchant",
  CouplingIsInProcess = "CouplingIsInProcess",
  InternalError = "InternalError",
}
